import { render, staticRenderFns } from "./EditQuestionPool.vue?vue&type=template&id=66912263"
import script from "./EditQuestionPool.vue?vue&type=script&lang=js"
export * from "./EditQuestionPool.vue?vue&type=script&lang=js"
import style0 from "./EditQuestionPool.vue?vue&type=style&index=0&id=66912263&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports